const Stepper = {
  baseStyle: {
    step: {
      gap: '0',
      maxW: '408px',
    },
    indicator: {
      color: 'text.black !important',
      border: '1.6px solid',
      borderColor: 'bg.accent !important',
      '&[data-status="incomplete"]': {
        borderColor: 'bg.gray !important',
      },
      '&[data-status="complete"]': {
        bgColor: 'bg.accent',
      },
    },
    separator: {
      bg: 'bg.white',
      ms: '0px !important',
      p: '0px 2px',
      bgImage: 'linear-gradient(to right, #fff 30%, bg.accent 30%)',
      bgSize: '30px 1.6px',
      bgRepeat: 'repeat-x',
      '&[data-status="complete"]': {
        bgColor: 'bg.accent',
      },
      '&[data-status="incomplete"]': {
        bgImage: 'linear-gradient(to right, #fff 30%, bg.gray 30%)',
      },
    },
  },
};

export default Stepper;
